import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom";
import { getUser, getCustomer, getFirmAdd } from "../../services/selectors";
import { getDataFromRoutes, setMetaTags, checkInput } from "../../utils/util_functions";
import styles from "../../components/firms/firms.module.css";
import { useDispatch } from "react-redux";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { ROUTES_CONST, DIRECTOR_POSTS, DIRECTOR_FOOTINGS } from "../../utils/constants";
import {
  EDIT_INN, EDIT_NAME, EDIT_SHORT_NAME, EDIT_OGRN, EDIT_KPP, EDIT_ADRESS, getFirmByInnThunk,
  CLEAR_FOUND_FIRM, SET_VALID_FORM, postAddFirmThunk, EDIT_BIK, EDIT_RASS_SCHET, EDIT_BANK_NAME,
  EDIT_KORR_SCHET, EDIT_DIRECTOR_NAME, EDIT_DIRECTOR_FOOTING, EDIT_DIRECTOR_POST, EDIT_EMAIL,
  postCreateFirmThunk, EDIT_DEFAULT_DEF_PAYMENT
} from "../../services/actions/firm_add_actions";
import { getCookie } from "../../utils/cookie";
import UserData from "../collapsed_data_list/user_data";
import { USER_ROLES } from "../../utils/constants";


const AddFirm = () => {

  const user = useSelector(getUser);
  const customer = useSelector(getCustomer);

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);


  useEffect(() => {
    // console.log(location.state);

    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  const {
    inn, name, short_name, ogrn, kpp, adress, found_firm, valid_form,
    rass_schet, bank_name, bik, korr_schet, director_name, director_footing,
    director_post, email, default_def_payment
  } = useSelector(getFirmAdd);

  const optionsDirectorPost = [
    { value: "", label: "--выберите должность--" },
    { value: DIRECTOR_POSTS.Director, label: DIRECTOR_POSTS.Director },
    { value: DIRECTOR_POSTS.GeneralDirector, label: DIRECTOR_POSTS.GeneralDirector },
    { value: DIRECTOR_POSTS.Predsedatel, label: DIRECTOR_POSTS.Predsedatel },
    { value: DIRECTOR_POSTS.Manager, label: DIRECTOR_POSTS.Manager },
    { value: DIRECTOR_POSTS.Ip, label: DIRECTOR_POSTS.Ip },
    { value: DIRECTOR_POSTS.Zaved, label: DIRECTOR_POSTS.Zaved },
    { value: DIRECTOR_POSTS.GeneralDoctor, label: DIRECTOR_POSTS.GeneralDoctor }
  ]

  const optionsDirectorFooting = [
    { value: "", label: "--выберите основание--" },
    { value: DIRECTOR_FOOTINGS.Ustav, label: DIRECTOR_FOOTINGS.Ustav },
    { value: DIRECTOR_FOOTINGS.Prikaz, label: DIRECTOR_FOOTINGS.Prikaz },
    { value: DIRECTOR_FOOTINGS.Doverennost, label: DIRECTOR_FOOTINGS.Doverennost },
    { value: DIRECTOR_FOOTINGS.Reshenie, label: DIRECTOR_FOOTINGS.Reshenie },
    { value: DIRECTOR_FOOTINGS.Svidetelstvo, label: DIRECTOR_FOOTINGS.Svidetelstvo }
  ]


  const [formBlockHidden, setFormBlockHidden] = useState(true);

  const [statusInn, setStatusInn] = useState({});
  const [statusName, setStatusName] = useState({});
  const [statusShortName, setStatusShortName] = useState({});
  const [statusOgrn, setStatusOgrn] = useState({});
  const [statusKpp, setStatusKpp] = useState({});
  const [statusAdress, setStatusAdress] = useState({});
  const [statusRassSchet, setStatusRassSchet] = useState({});
  const [statusBankName, setStatusBankName] = useState({});
  const [statusBik, setStatusBik] = useState({});
  const [statusKorrSchet, setStatusKorrSchet] = useState({});
  const [statusDirectorName, setStatusDirectorName] = useState({});
  const [statusDirectorFooting, setStatusDirectorFooting] = useState({});
  const [statusDirectorPost, setStatusDirectorPost] = useState({});
  const [statusEmail, setStatusEmail] = useState({});
  const [statusDefaultDefPayment, setStatusDefaultDefPayment] = useState({valid: true, text: ''});

  const changeDirectorPost = (e) => {
    const currStatus = e.target.value !== "" ? { valid: true, text: '' } : { valid: false, text: 'Выберите должность' };
    setStatusDirectorPost({ ...statusDirectorPost, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_DIRECTOR_POST, director_post: e.target.value });
  }
  const changeDirectorFooting = (e) => {
    const currStatus = e.target.value !== "" ? { valid: true, text: '' } : { valid: false, text: 'Выберите основание' };
    setStatusDirectorFooting({ ...statusDirectorFooting, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_DIRECTOR_FOOTING, director_footing: e.target.value });
  }


  const changeInn = (e) => {
    if (e.target.value.length > 12) {
      e.target.value = e.target.value.slice(0, 12);
    }
    const currStatus = checkInput(e.target.value, 10, 12, 'inn');
    setStatusInn({ ...statusInn, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_INN, inn: e.target.value });
    const length = e.target.value.length;
    if (length === 10 || length === 12) {
      getFirmByInn(e.target.value);
      setFormBlockHidden(false);
    } else {
      setFormBlockHidden(true);
      dispatch({ type: CLEAR_FOUND_FIRM });
    }
  }
  const changeName = (e) => {
    if (e.target.value.length > 254) {
      e.target.value = e.target.value.slice(0, 254);
    }
    const currStatus = checkInput(e.target.value, 6, 254, 'string');
    setStatusName({ ...statusName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_NAME, name: e.target.value });
  }
  const changeShortName = (e) => {
    if (e.target.value.length > 40) {
      e.target.value = e.target.value.slice(0, 40);
    }
    const currStatus = checkInput(e.target.value, 4, 40, 'string');
    setStatusShortName({ ...statusShortName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_SHORT_NAME, short_name: e.target.value });
  }
  const changeOgrn = (e) => {
    if (e.target.value.length > 15) {
      e.target.value = e.target.value.slice(0, 15);
    }
    const currStatus = checkInput(e.target.value, 13, 15, 'ogrn');
    setStatusOgrn({ ...statusOgrn, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_OGRN, ogrn: e.target.value });
  }
  const changeKpp = (e) => {
    if (e.target.value.length > 9) {
      e.target.value = e.target.value.slice(0, 9);
    }
    const currStatus = checkInput(e.target.value, 9, 9, 'number');
    setStatusKpp({ ...statusKpp, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_KPP, kpp: e.target.value });
  }
  const changeAdress = (e) => {
    if (e.target.value.length > 254) {
      e.target.value = e.target.value.slice(0, 254);
    }
    const currStatus = checkInput(e.target.value, 20, 254, 'string');
    setStatusAdress({ ...statusAdress, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_ADRESS, adress: e.target.value });
  }
  const changeBik = (e) => {
    if (e.target.value.length > 9) {
      e.target.value = e.target.value.slice(0, 9);
    }
    const currStatus = checkInput(e.target.value, 9, 9, 'number');
    setStatusBik({ ...statusBik, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_BIK, bik: e.target.value });
  }
  const changeBankName = (e) => {
    if (e.target.value.length > 120) {
      e.target.value = e.target.value.slice(0, 120);
    }
    const currStatus = checkInput(e.target.value, 6, 120, 'string');
    setStatusBankName({ ...statusBankName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_BANK_NAME, bank_name: e.target.value });
  }
  const changeKorrSchet = (e) => {
    if (e.target.value.length > 20) {
      e.target.value = e.target.value.slice(0, 20);
    }
    const currStatus = checkInput(e.target.value, 20, 20, 'number');
    setStatusKorrSchet({ ...statusKorrSchet, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_KORR_SCHET, korr_schet: e.target.value });
  }
  const changeRassSchet = (e) => {
    if (e.target.value.length > 20) {
      e.target.value = e.target.value.slice(0, 20);
    }
    const currStatus = checkInput(e.target.value, 20, 20, 'number');
    setStatusRassSchet({ ...statusRassSchet, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_RASS_SCHET, rass_schet: e.target.value });
  }
  const changeDirectorName = (e) => {
    if (e.target.value.length > 60) {
      e.target.value = e.target.value.slice(0, 60);
    }
    const currStatus = checkInput(e.target.value, 6, 60, 'string');
    setStatusDirectorName({ ...statusDirectorName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_DIRECTOR_NAME, director_name: e.target.value });
  }
  const changeEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 6, 64, 'email');
    setStatusEmail({ ...statusEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_EMAIL, email: e.target.value });
  }
  const changeDefaultDefPayment = (e) => {
    if (e.target.value.length > 3) {
      e.target.value = e.target.value.slice(0, 3);
    }
    const currStatus = checkInput(e.target.value, 0, 120, 'digits');
    setStatusDefaultDefPayment({ ...statusDefaultDefPayment, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_DEFAULT_DEF_PAYMENT, default_def_payment: e.target.value });
  }


  useEffect(() => {
    const all_inputs_valid = statusInn?.valid && statusName?.valid && statusShortName?.valid &&
      statusOgrn?.valid && statusKpp?.valid && statusAdress?.valid && statusBik?.valid &&
      statusRassSchet?.valid && statusBankName?.valid && statusKorrSchet?.valid && statusEmail?.valid &&
      statusDirectorName?.valid && statusDirectorFooting?.valid && statusDirectorPost?.valid &&
      statusDefaultDefPayment?.valid;

    dispatch({
      type: SET_VALID_FORM, valid_form: all_inputs_valid || Object.keys(found_firm).length > 0
    });

    // eslint-disable-next-line
  }, [inn, name, short_name, ogrn, kpp, adress, bik, rass_schet, bank_name,
    korr_schet, director_name, director_footing, director_post, email, default_def_payment
  ]);



  const handleSubmit = (e) => {
    e.preventDefault();
    if (found_firm?.inn) {
      dispatch(postAddFirmThunk(
        accessToken, refreshToken,
        navigate, found_firm.inn, customer.id,
        location.state?.from.pathname || ''
      ));
    } else {
      const data = {
        inn,
        name,
        short_name,
        ogrn,
        kpp,
        adress,
        rass_schet,
        bank_name,
        bik,
        korr_schet,
        director_name,
        director_footing,
        director_post,
        email,
        default_def_payment
      }
      dispatch(postCreateFirmThunk(
        accessToken, refreshToken, navigate, data, customer.id,
        location.state?.from.pathname || ''
      ));
    }

    // if (location.state?.from.pathname === '/new_order') {
    //   console.log('идём в ', location.state?.from.pathname);
    //   navigate('/new_order', { replace: true });
    // }
  }

  const getFirmByInn = (inn) => {
    dispatch(
      getFirmByInnThunk(accessToken, refreshToken, inn)
    );
  }

  return (
    <>
      <h2 className='subtitle ml0 mb15'>Добавление организации</h2>
      {(user.role === USER_ROLES.manager || user.role === USER_ROLES.superuser) &&
        <div className={styles.find_user_container}>
          <UserData customer={customer} />
        </div>
      }
      <form onSubmit={handleSubmit} className="form" noValidate>
        <label htmlFor="inn" className="label_text">
          ИНН
          <input
            type="number"
            id="inn" name="inn"
            required={true}
            value={inn}
            onChange={changeInn}
            className="input"
            placeholder="10 или 12 цифр"
          />
          <p className="error">{statusInn?.text}</p>
        </label>
        <div className={`${styles.formBlock} ${formBlockHidden && styles.formBlock__hidden}`}>
          <label htmlFor="name" className="label_text">
            Полное название
            <input
              type="text"
              id="name" name="name"
              required={true}
              value={name}
              onChange={changeName}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="6 - 254 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusName?.text}</p>
          </label>
          <label htmlFor="name" className="label_text">
            Сокращённое название
            <input
              type="text"
              id="short_name" name="short_name"
              required={true}
              value={short_name}
              onChange={changeShortName}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="4 - 40 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusShortName?.text}</p>
          </label>
          <label htmlFor="ogrn" className="label_text">
            ОГРН (ОГРНИП)
            <input
              type="number"
              id="ogrn" name="ogrn"
              required={true}
              value={ogrn}
              onChange={changeOgrn}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="13 или 15 цифр"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusOgrn?.text}</p>
          </label>

          <label htmlFor="kpp" className="label_text">
            КПП
            <input
              type="number"
              id="kpp" name="kpp"
              required={true}
              value={kpp}
              onChange={changeKpp}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="9 цифр (нули для ИП)"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusKpp?.text}</p>
          </label>
          <label htmlFor="adress" className="label_text">
            Юридический адрес
            <input
              type="text"
              id="adress" name="adress"
              required={true}
              value={adress}
              onChange={changeAdress}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="20 - 254 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusAdress?.text}</p>
          </label>
          <label htmlFor="bik" className="label_text">
            БИК
            <input
              type="number"
              id="bik" name="bik"
              required={true}
              value={bik}
              onChange={changeBik}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="9 цифр"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusBik?.text}</p>
          </label>
          <label htmlFor="name" className="label_text">
            Название банка
            <input
              type="text"
              id="bank_name" name="bank_name"
              required={true}
              value={bank_name}
              onChange={changeBankName}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="6 - 120 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusBankName?.text}</p>
          </label>
          <label htmlFor="korr_schet" className="label_text">
            Корреспондентский счёт
            <input
              type="number"
              id="korr_schet" name="korr_schet"
              required={true}
              value={korr_schet}
              onChange={changeKorrSchet}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="20 цифр"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusKorrSchet?.text}</p>
          </label>
          <label htmlFor="rass_schet" className="label_text">
            Расчётный счёт
            <input
              type="number"
              id="rass_schet" name="rass_schet"
              required={true}
              value={rass_schet}
              onChange={changeRassSchet}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="20 цифр"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusRassSchet?.text}</p>
          </label>
          <label htmlFor="name" className="label_text">
            ФИО руководителя
            <input
              type="text"
              id="director_name" name="director_name"
              required={true}
              value={director_name}
              onChange={changeDirectorName}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="6 - 60 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusDirectorName?.text}</p>
          </label>
          <label htmlFor="director_post" className="label_text">
            Должность руководителя
            <select
              value={director_post}
              onChange={changeDirectorPost}
              className="input"
              disabled={!!found_firm?.inn}
            >
              {
                optionsDirectorPost.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              }
            </select>
            <p className="error">{statusDirectorPost?.text}</p>
          </label>
          <label htmlFor="director_post" className="label_text">
            Руководитель на основании
            <select
              value={director_footing}
              onChange={changeDirectorFooting}
              className="input"
              disabled={!!found_firm?.inn}
            >
              {
                optionsDirectorFooting.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))
              }
            </select>
            <p className="error">{statusDirectorFooting?.text}</p>
          </label>
          <label htmlFor="email" className="label_text">
            Email организации
            <input
              type="email"
              id="email" name="email"
              required={true}
              value={email}
              onChange={changeEmail}
              className={`input ${found_firm?.inn && styles.input__disabled}`}
              placeholder="6 - 40 символов"
              readOnly={!!found_firm?.inn}
            />
            <p className="error">{statusEmail?.text}</p>
          </label>
          {(user.role === USER_ROLES.manager || user.role === USER_ROLES.superuser) &&
            <label htmlFor="default_def_payment" className="label_text">
              Отсрочка оплаты
              <input
                type="number"
                id="default_def_payment" name="default_def_payment"
                required={true}
                value={default_def_payment}
                onChange={changeDefaultDefPayment}
                className={`input ${found_firm?.inn && styles.input__disabled}`}
                placeholder="от 0 до 120 дней"
                readOnly={!!found_firm?.inn}
              />
              <p className="error">{statusDefaultDefPayment?.text}</p>
            </label>
          }
          <button type="submit"
            className={`button ${!valid_form ? 'button_disabled' : ''}`}
            disabled={!valid_form}
          >
            Добавить
          </button>
        </div>
      </form>
    </>
  )
}

export default AddFirm;
